import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "col-12 mb-4"
}
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-header d-flex" }
const _hoisted_4 = {
  key: 0,
  class: "btn btn-secondary ms-auto",
  "data-bs-toggle": "modal",
  "data-bs-target": "#ticketModal"
}
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = {
  key: 0,
  class: "text-center w-75 mx-auto"
}
const _hoisted_7 = {
  key: 1,
  class: "text-center w-75 mx-auto"
}
const _hoisted_8 = {
  key: 2,
  class: "list-group"
}
const _hoisted_9 = {
  key: 1,
  class: "col-12 col-md-6 mx-auto vh-100 d-flex align-items-center justify-content-center"
}
const _hoisted_10 = { class: "card" }
const _hoisted_11 = { class: "card-body text-center px-5" }
const _hoisted_12 = {
  key: 2,
  class: "modal fade",
  id: "ticketModal",
  tabindex: "-1",
  "aria-labelledby": "ticketModalLabel",
  "aria-hidden": "true"
}
const _hoisted_13 = { class: "modal-dialog modal-lg" }
const _hoisted_14 = { class: "modal-content" }
const _hoisted_15 = { class: "modal-body" }
const _hoisted_16 = { class: "row my-5" }
const _hoisted_17 = { class: "col" }
const _hoisted_18 = { class: "input-group d-flex w-100" }
const _hoisted_19 = {
  class: "form-floating",
  style: {"flex":"1"}
}
const _hoisted_20 = ["disabled"]
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "col-md-3 mt-2 mt-md-0 d-flex align-items-center justify-content-end" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = {
  key: 0,
  class: "mb-5"
}
const _hoisted_26 = {
  key: 1,
  class: "row mb-5"
}
const _hoisted_27 = { class: "col-md-4 mt-3 mx-auto" }
const _hoisted_28 = { class: "form-floating" }
const _hoisted_29 = { class: "col-md-8 mt-3 mx-auto" }
const _hoisted_30 = { class: "form-floating" }
const _hoisted_31 = ["value"]
const _hoisted_32 = { class: "col-md-6 mt-3 mx-auto" }
const _hoisted_33 = { class: "form-floating" }
const _hoisted_34 = { class: "col-md-6 mt-3 mx-auto" }
const _hoisted_35 = { class: "form-floating" }
const _hoisted_36 = { class: "col-md-4 mt-3 mx-auto" }
const _hoisted_37 = { class: "form-floating" }
const _hoisted_38 = { class: "col-md-8 mt-3 mx-auto" }
const _hoisted_39 = { class: "form-floating" }
const _hoisted_40 = {
  key: 2,
  class: "row mb-5"
}
const _hoisted_41 = {
  key: 0,
  class: "col-md-6 mt-3 mx-auto"
}
const _hoisted_42 = { class: "input-group" }
const _hoisted_43 = { class: "form-floating w-25" }
const _hoisted_44 = ["value"]
const _hoisted_45 = {
  key: 3,
  class: "row mb-5"
}
const _hoisted_46 = {
  key: 0,
  class: "col-md-6 mt-3 mx-auto"
}
const _hoisted_47 = { class: "modal-footer" }
const _hoisted_48 = ["disabled"]
const _hoisted_49 = {
  key: 1,
  class: "col-12 col-md-6 mx-auto vh-100 d-flex align-items-center justify-content-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_spinner = _resolveComponent("loader-spinner")!
  const _component_ticket_header = _resolveComponent("ticket-header")!
  const _component_list_items = _resolveComponent("list-items")!
  const _component_team_member = _resolveComponent("team-member")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_loader_spinner, { show: _ctx.loading }, null, 8, ["show"]),
    (_ctx.eventActive && !_ctx.loading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_ticket_header, {
            ticketsInfo: _ctx.ticketsInfo,
            event: _ctx.event
          }, null, 8, ["ticketsInfo", "event"]),
          (_ctx.ticketsInfo?.count?.total > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _cache[15] || (_cache[15] = _createElementVNode("h5", null, "Boletos compartidos", -1)),
                    (_ctx._pendingTickets > 0)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_4, " Compartir "))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    (_ctx.transferedTickets.length == 0 && _ctx._pendingTickets > 0)
                      ? (_openBlock(), _createElementBlock("h3", _hoisted_6, [...(_cache[16] || (_cache[16] = [
                          _createTextVNode(" Aún no haz compartido boletos.", -1),
                          _createElementVNode("br", null, null, -1),
                          _createTextVNode(" Haz click ", -1),
                          _createElementVNode("a", {
                            href: "#",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#ticketModal"
                          }, " aquí ", -1),
                          _createTextVNode(" para comenzar a compartir tus boletos. ", -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.transferedTickets.length == 0 && _ctx._pendingTickets == 0)
                      ? (_openBlock(), _createElementBlock("h3", _hoisted_7, [...(_cache[17] || (_cache[17] = [
                          _createTextVNode(" Aún tienes ticket pendientes de pago.", -1),
                          _createElementVNode("br", null, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.transferedTickets.length > 0)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                          _cache[18] || (_cache[18] = _createStaticVNode("<li class=\"list-group-item d-flex justify-content-between align-items-center bg-gray text-white\" data-v-2f3190a1><div class=\"d-flex align-items-start w-100 flex-column flex-md-row align-items-md-center\" data-v-2f3190a1><div class=\"w-25 w-md-25 ms-2\" data-v-2f3190a1><p class=\"m-0\" data-v-2f3190a1><strong data-v-2f3190a1>Nombre</strong></p></div><div class=\"ms-2 w-25\" data-v-2f3190a1><p class=\"m-0\" data-v-2f3190a1><strong data-v-2f3190a1>Tipo</strong></p></div><div class=\"ms-2\" data-v-2f3190a1><p class=\"m-0\" data-v-2f3190a1><strong data-v-2f3190a1>Ultimo asignado</strong></p></div></div><strong data-v-2f3190a1>Boleto</strong></li>", 1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transferedTickets, (ticket, ind) => {
                            return (_openBlock(), _createBlock(_component_list_items, {
                              key: ind,
                              ticket: ticket
                            }, null, 8, ["ticket"]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.ticketsInfo?.count?.total == 0 && !_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _cache[20] || (_cache[20] = _createElementVNode("h1", null, [
                      _createElementVNode("i", {
                        style: {"font-size":"2em"},
                        class: "fas fa-ticket-alt"
                      })
                    ], -1)),
                    _cache[21] || (_cache[21] = _createElementVNode("h2", { class: "mb-4" }, "No haz comprado boletos", -1)),
                    _cache[22] || (_cache[22] = _createElementVNode("p", { class: "px-5" }, " Aún no haz comprado boletos. Para continuar dirigete a la sección de eventos y compra el(los) boleto(s) de tu preferencia. ", -1)),
                    _createElementVNode("button", {
                      class: "btn btn-primary mb-2",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBuyTickets && _ctx.goBuyTickets(...args)))
                    }, [...(_cache[19] || (_cache[19] = [
                      _createElementVNode("i", { class: "fas fa-ticket-alt me-1" }, null, -1),
                      _createTextVNode(" Comprar boletos ", -1)
                    ]))])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.ticketsInfo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _cache[40] || (_cache[40] = _createElementVNode("div", { class: "modal-header" }, [
                      _createElementVNode("h1", {
                        class: "modal-title fs-5",
                        id: "ticketModalLabel"
                      }, "Comparte un nuevo boleto"),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn-close",
                        "data-bs-dismiss": "modal",
                        "aria-label": "Close"
                      })
                    ], -1)),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("p", null, [
                        _cache[23] || (_cache[23] = _createTextVNode("Cuentas con ", -1)),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.ticketsInfo?.count?.availableTickets ?? 0) + " boletos", 1),
                        _cache[24] || (_cache[24] = _createTextVNode(" disponibles para compartir entre tus afiliados de red unilevel. Selecciona el nombre del afiliado a quien quiere compartir este boleto. ", -1))
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-control",
                                placeholder: "Buscar afiliado",
                                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.searchUser && _ctx.searchUser(...args))),
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchUserValue) = $event)),
                                disabled: _ctx.guest
                              }, null, 40, _hoisted_20), [
                                [_vModelText, _ctx.searchUserValue]
                              ]),
                              _cache[25] || (_cache[25] = _createElementVNode("label", { for: "floatingInput" }, "Buscar afiliado", -1))
                            ]),
                            _createElementVNode("button", {
                              disabled: _ctx.guest,
                              class: "btn btn-secondary",
                              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.searchUser && _ctx.searchUser(...args)))
                            }, "Buscar", 8, _hoisted_21)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("button", {
                            class: "btn btn-secondary w-100 h-100",
                            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.setGuest && _ctx.setGuest(...args)))
                          }, [
                            (!_ctx.guest)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_23, "Compartir con invitado"))
                              : _createCommentVNode("", true),
                            (_ctx.guest)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_24, "Regresar"))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      (_ctx.guest)
                        ? (_openBlock(), _createElementBlock("hr", _hoisted_25))
                        : _createCommentVNode("", true),
                      (_ctx.guest)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _cache[33] || (_cache[33] = _createElementVNode("div", { class: "col-12" }, [
                              _createElementVNode("h4", null, "Ingresa los datos de tu invitado.")
                            ], -1)),
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("div", _hoisted_28, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-control",
                                  placeholder: "Cantidad",
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.ticketQuantity) = $event)),
                                  type: "number"
                                }, null, 512), [
                                  [_vModelText, _ctx.ticketQuantity]
                                ]),
                                _cache[26] || (_cache[26] = _createElementVNode("label", { for: "floatingInput" }, "Cantidad", -1))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("div", _hoisted_30, [
                                _withDirectives(_createElementVNode("select", {
                                  class: "form-select h-100",
                                  required: "",
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedOption) = $event))
                                }, [
                                  _cache[27] || (_cache[27] = _createElementVNode("option", {
                                    disabled: "",
                                    selected: "",
                                    value: ""
                                  }, "Selecciona el tipo de boleto", -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: option.id,
                                      value: option.id
                                    }, _toDisplayString(option.name) + " (" + _toDisplayString(option.count) + " Disponibles) ", 9, _hoisted_31))
                                  }), 128))
                                ], 512), [
                                  [_vModelSelect, _ctx.selectedOption]
                                ]),
                                _cache[28] || (_cache[28] = _createElementVNode("label", { for: "floatingInput" }, "Tipo de boleto", -1))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("div", _hoisted_33, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-control",
                                  placeholder: "Buscar afiliado",
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.first_name) = $event)),
                                  required: ""
                                }, null, 512), [
                                  [_vModelText, _ctx.first_name]
                                ]),
                                _cache[29] || (_cache[29] = _createElementVNode("label", { for: "floatingInput" }, "Nombre", -1))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_34, [
                              _createElementVNode("div", _hoisted_35, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-control",
                                  placeholder: "Buscar afiliado",
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.last_name) = $event)),
                                  required: ""
                                }, null, 512), [
                                  [_vModelText, _ctx.last_name]
                                ]),
                                _cache[30] || (_cache[30] = _createElementVNode("label", { for: "floatingInput" }, "Apellido", -1))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("div", _hoisted_37, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-control",
                                  placeholder: "Buscar afiliado",
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.phone) = $event)),
                                  required: ""
                                }, null, 512), [
                                  [_vModelText, _ctx.phone]
                                ]),
                                _cache[31] || (_cache[31] = _createElementVNode("label", { for: "floatingInput" }, "Teléfono", -1))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_38, [
                              _createElementVNode("div", _hoisted_39, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-control",
                                  placeholder: "Buscar afiliado",
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.email) = $event)),
                                  required: "",
                                  type: "email"
                                }, null, 512), [
                                  [_vModelText, _ctx.email]
                                ]),
                                _cache[32] || (_cache[32] = _createElementVNode("label", { for: "floatingInput" }, "Correo Electrónico", -1))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.selected && !_ctx.guest)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                            (!_ctx.selectedError)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                  (_openBlock(), _createBlock(_component_team_member, {
                                    simple: true,
                                    key: _ctx.selected.usernamePK,
                                    "member-data": _ctx.selected,
                                    maxPointsPerUser: _ctx.selected.nextRankMaxPoints,
                                    "team-side": 'true'
                                  }, null, 8, ["member-data", "maxPointsPerUser"])),
                                  _createElementVNode("div", _hoisted_42, [
                                    _createElementVNode("div", _hoisted_43, [
                                      _withDirectives(_createElementVNode("input", {
                                        class: "form-control",
                                        placeholder: "Cantidad",
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.ticketQuantity) = $event)),
                                        type: "number"
                                      }, null, 512), [
                                        [_vModelText, _ctx.ticketQuantity]
                                      ]),
                                      _cache[34] || (_cache[34] = _createElementVNode("label", { for: "floatingInput" }, "Cantidad", -1))
                                    ]),
                                    _withDirectives(_createElementVNode("select", {
                                      class: "form-select",
                                      required: "",
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectedOption) = $event))
                                    }, [
                                      _cache[35] || (_cache[35] = _createElementVNode("option", {
                                        value: "",
                                        selected: "",
                                        disabled: ""
                                      }, "Selecciona el tipo de boleto", -1)),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          key: option.id,
                                          value: option.id
                                        }, _toDisplayString(option.name) + " (" + _toDisplayString(option.count) + ") ", 9, _hoisted_44))
                                      }), 128))
                                    ], 512), [
                                      [_vModelSelect, _ctx.selectedOption]
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.selectedError)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                            (_ctx.selectedError)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_46, [...(_cache[36] || (_cache[36] = [
                                  _createElementVNode("h4", { class: "mb-0 text-center" }, [
                                    _createElementVNode("i", { class: "fas fa-user-slash fa-fw me-2" }),
                                    _createTextVNode("Usuario no encontrado ")
                                  ], -1)
                                ]))]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _cache[39] || (_cache[39] = _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-secondary d-none d-md-block",
                        "data-bs-dismiss": "modal"
                      }, "Cerrar", -1)),
                      (_ctx.selected)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-danger",
                            onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.removeSelected && _ctx.removeSelected(...args)))
                          }, [...(_cache[37] || (_cache[37] = [
                            _createElementVNode("i", {
                              class: "fas fa-times text-white me-2",
                              title: "Afiliado de derecha"
                            }, null, -1),
                            _createTextVNode("Eliminar afiliado", -1)
                          ]))]))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        "data-bs-dismiss": "modal",
                        type: "button",
                        class: "btn btn-success text-white",
                        disabled: _ctx.buttonDisabled,
                        onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.setTicket && _ctx.setTicket(...args)))
                      }, [...(_cache[38] || (_cache[38] = [
                        _createElementVNode("i", { class: "fas fa-ticket-alt text-white" }, null, -1),
                        _createTextVNode(" Asignar boleto", -1)
                      ]))], 8, _hoisted_48)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (!_ctx.eventActive && !_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_49, [...(_cache[41] || (_cache[41] = [
          _createStaticVNode("<div class=\"card\" data-v-2f3190a1><div class=\"card-body text-center px-5\" data-v-2f3190a1><h1 data-v-2f3190a1><i style=\"font-size:2em;\" class=\"fas fa-ticket-alt\" data-v-2f3190a1></i></h1><h2 class=\"mb-2\" data-v-2f3190a1>No hay eventos disponibles</h2><p class=\"px-5\" data-v-2f3190a1> Por el momento no hay eventos activos. </p></div></div>", 1)
        ]))]))
      : _createCommentVNode("", true)
  ], 64))
}